import { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { Modal, Button, Table } from "react-bootstrap";
import { get_archivos_oferta, get_archivo_by_id, delete_archivo_oferta } from "../../services/documentos";
import { CiWarning } from "react-icons/ci";
import { MdDeleteForever, MdDownload } from "react-icons/md";
import SubirArchivoOferta from "../../components/modals/SubirArchivoOferta";
import { LuFileUp } from "react-icons/lu";


function GestionArchivosOferta({ oferta, show, close, handleClose, onClose }) {
  const [loading, setLoading] = useState(false);
  const [archivos, setArchivos] = useState(false);
  const [showSubirArchivoOferta, setShowSubirArchivoOferta] = useState(false);
  const [ofertaActiva, setOfertaActivo] = useState(false);

  const signaturitStatus =
    [
      { id: "pending", name: "Pendiente de envio" },
      { id: "ready", name: "Pendiente de firma" },
      { id: "completed", name: "Firma Finalizada" },
      { id: "expired", name: "Plazo expirado" },
      { id: "canceled", name: "Firma cancelada" },
      { id: "error", name: "Error" },
      { id: "declined", name: "Firma declinada" },
      { id: "signing", name: "En proceso de firma" },
      { id: "in_queue", name: "En cola para envio" },
    ];


  const getArchivos = useCallback(async () => {
    if (!oferta?.id) return;
    setLoading(true);
    const data = await get_archivos_oferta(oferta.id);
    setArchivos(data);
    setLoading(false);
  }, [oferta?.id]);

  useEffect(() => {
    if (show) {
      getArchivos();
    }
  }, [show, getArchivos]);

  const openModalSubirArchivo = (id, name) => {
    setOfertaActivo({ id, name });
    setShowSubirArchivoOferta(true);
  };

  const closeModal = () => {
    if (typeof handleClose === "function") {
      handleClose();
      return;
    }

    if (typeof close === "function") {
      close(false);
    }
  };

  const cerrar = () => {
    closeModal();
    if (onClose) {
      onClose();
    }
  };

  // Función para determinar el tipo MIME y la extensión
  const determineContentTypeAndExtension = (base64Data) => {
    if (!base64Data) return { contentType: "application/octet-stream", extension: "bin" };
    if (base64Data.startsWith("iVBORw0KGgo")) {
      return { contentType: "image/png", extension: "png" };
    }
    if (base64Data.startsWith("/9j/")) {
      return { contentType: "image/jpeg", extension: "jpg" };
    }
    if (base64Data.startsWith("JVBERi0")) {
      return { contentType: "application/pdf", extension: "pdf" };
    }
    // Añade más tipos si es necesario
    return { contentType: "application/octet-stream", extension: "bin" }; // Valor por defecto
  };

  const descargarArchivo = async (attach_id) => {
    try {
      const archivo = await get_archivo_by_id(attach_id);
      Object.keys(archivo).forEach((arch) => {
        const { datas: base64Data, name: originalName } = archivo[arch];
        const { contentType, extension } = determineContentTypeAndExtension(base64Data);

        // Decodifica el base64
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Crea un Blob con el tipo MIME adecuado
        const blob = new Blob([byteArray], { type: contentType });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);

        // Usa el nombre original si está disponible, o genera un nombre genérico
        link.download = originalName || `archivo.${extension}`;
        link.click();
        URL.revokeObjectURL(link.href);
      });
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    }
  };

  const eliminarArchivo = async (crm_documentacio_id) => {
    try {
      await delete_archivo_oferta(crm_documentacio_id);
    } catch (error) { } finally {
      getArchivos()
    }
  };

  return (
    <Modal
      show={show}
      onHide={cerrar}
      size="lg"
      backdrop="static"
      centered
      contentClassName="border-0 rounded-4 shadow-lg"
    >
      <Modal.Header className="bg-white border-bottom-0" closeButton>
        <div className="d-flex flex-column">
          <Modal.Title className="fw-bold text-primary">Gestión de archivos Oferta</Modal.Title>
          <span className="text-muted small">Nº {oferta?.name || ''}</span>
        </div>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="p-3">
          {loading ? (
            <div
              style={{ height: "40vh" }}
              className="d-flex flex-column justify-content-center align-items-center text-muted"
            >
              <div className="spinner-border text-primary mb-3" role="status"></div>
              <h5 className="fw-bold">Cargando archivos...</h5>
            </div>
          ) : (archivos && archivos.length > 0) ? (
            <div
              style={{ height: "40vh", overflowY: "auto" }}
              className="rounded-3 border border-light shadow-sm"
            >
              <Table
                striped
                hover
                borderless
                className="mb-0"
              >
                <thead className="bg-light sticky-top">
                  <tr>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Nombre</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Tipo</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Estado Firma</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Tipo Firma</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase text-end">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {archivos &&
                    archivos.map((archivo) => {
                      return (
                        <tr key={archivo.id} className="align-middle">
                          <td className="px-4 py-3 text-secondary fw-bold">{archivo.attach_id[1]}</td>
                          <td className="px-4 py-3 text-muted">{archivo.tipus_document}</td>
                          <td className="px-4 py-3 text-muted">
                            {signaturitStatus.find(status => status.id === archivo.signaturit_status)?.name || " "}
                          </td>
                          <td className="px-4 py-3 text-muted">{archivo.signaturit_type}</td>
                          <td className="px-4 py-3 text-end">
                            <div className="d-flex justify-content-end gap-2">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="rounded-circle p-2 d-flex align-items-center justify-content-center"
                                title="Descargar archivo"
                                style={{ width: '32px', height: '32px' }}
                                onClick={() => descargarArchivo(archivo.attach_id[0])}
                              >
                                <MdDownload />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                className="rounded-circle p-2 d-flex align-items-center justify-content-center"
                                title="Eliminar archivo"
                                style={{ width: '32px', height: '32px' }}
                                onClick={() => eliminarArchivo(archivo.id)}
                              >
                                <MdDeleteForever />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div style={{ height: "40vh" }} className="d-flex flex-column justify-content-center align-items-center text-center opacity-75">
              <CiWarning className="display-1 text-muted mb-3" />
              <h4 className="text-muted fw-bold mb-3">No hay archivos disponibles.</h4>
              <Button
                className="rounded-pill px-4 fw-bold shadow-sm"
                variant="primary"
                onClick={() => getArchivos()}
              >
                Reintentar
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0 pb-4">
        <Button
          className="rounded-pill px-4 fw-bold shadow-sm d-flex align-items-center gap-2"
          variant="primary"
          title="Subir archivo"
          onClick={() =>
            openModalSubirArchivo(
              oferta?.id,
              oferta?.name,
              oferta?.sector_type
            )
          }
        >
          <LuFileUp />
          Subir archivo
        </Button>

      </Modal.Footer>
      <SubirArchivoOferta
        show={showSubirArchivoOferta}
        close={setShowSubirArchivoOferta}
        oferta={ofertaActiva}
        onUploadSuccess={getArchivos}
      />
    </Modal>
  );
}

export default connect()(GestionArchivosOferta);
